import React from 'react'
import { Grid, Typography } from '@the-platform-group/component-library'
import { Button } from '@the-platform-group/component-library/Button'
import { ModalContent, ModalTitle, ModalActions } from '@the-platform-group/component-library/Modal'

const CustomerRequestInstructionModalDelete = ({
  handleClose,
  customer,
  instructionToDelete,
  handleInstructionDelete,
}) => {
  return (
    <>
      <ModalTitle title="Delete instructions" />
      <ModalContent>
        <Typography variant="body2" paragraph>
          Are you sure you want to delete instructions for <strong>"{customer.name}"</strong>? Once
          deleted, it cannot be recovered or accessed again.
        </Typography>
      </ModalContent>
      <ModalActions>
        <Grid container spacing={2} justifyContent="flex-end">
          <Grid item>
            <Button onClick={() => handleClose()} variant="text">
              Cancel
            </Button>
            <Button
              onClick={() => {
                handleInstructionDelete(instructionToDelete.id)
                handleClose()
              }}
            >
              Delete
            </Button>
          </Grid>
        </Grid>
      </ModalActions>
    </>
  )
}

export default CustomerRequestInstructionModalDelete
